import * as Sentry from '@sentry/react';

import getEnv from './utils/getEnv';

const { REACT_APP_SENTRY_DSN, REACT_APP_STAGE } = getEnv();

// Non-actionable browser/runtime noise that otherwise floods production:
// resize-observer warnings, extension-injected errors, and transient network
// blips that the user's own connection (not our code) caused.
const IGNORED_ERRORS = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  'Non-Error promise rejection captured',
  'Network request failed',
  'Failed to fetch',
  'NetworkError when attempting to fetch resource.',
  'Load failed'
];

// Errors thrown from browser extensions / injected scripts are not ours.
const DENY_URLS = [
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari-(web-)?extension:\/\//i
];

Sentry.init({
  dsn: REACT_APP_SENTRY_DSN,
  environment: REACT_APP_STAGE,
  // Report only from production; dev and staging stay out of Sentry.
  enabled: REACT_APP_STAGE === 'production',
  // Sample performance traces lightly to keep event volume manageable.
  tracesSampleRate: 0.1,
  ignoreErrors: IGNORED_ERRORS,
  denyUrls: DENY_URLS
});
